import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'core-js/features/array/includes'
import 'core-js/web/url-search-params'
import {IEIntlPolyfill} from 'utility'

IEIntlPolyfill()
